import * as Modems from './Modems';
import * as TransportConfig from './TransportApp';
import * as Snackbar from './AlertSnackbarStore';
import * as Users from './Users';
import * as WebSocketStore from './WebSocketStore';

// The top-level state object
export interface ApplicationState {
    modems: Modems.ModemsState | undefined;
    transportAppState: TransportConfig.TransportAppState | undefined;
    snackbar: Snackbar.SnackbarState | undefined;
    users: Users.UsersState | undefined;
    webSocket: WebSocketStore.WebSocketState | undefined
}

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers = {
    modems: Modems.reducer,
    transportAppState: TransportConfig.reducer,
    snackbar: Snackbar.reducer,
    users: Users.reducer,
    webSocket: WebSocketStore.reducer
};

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export interface AppThunkAction<TAction> {
    (dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
}

export interface AppThunkFunc<TAction, TReturn> {
    (dispatch: (action: TAction) => Promise<TReturn>, getState: () => ApplicationState): Promise<TReturn>;
}